/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { AddressFromJSON, AddressToJSON, } from './Address';
import { BountyLocationFromJSON, BountyLocationToJSON, } from './BountyLocation';
import { PreviewIncidentReportFootageDtoFromJSON, PreviewIncidentReportFootageDtoToJSON, } from './PreviewIncidentReportFootageDto';
import { PreviewIncidentReportImageDtoFromJSON, PreviewIncidentReportImageDtoToJSON, } from './PreviewIncidentReportImageDto';
/**
 * Check if a given object implements the PreviewIncidentReportResponse interface.
 */
export function instanceOfPreviewIncidentReportResponse(value) {
    let isInstance = true;
    return isInstance;
}
export function PreviewIncidentReportResponseFromJSON(json) {
    return PreviewIncidentReportResponseFromJSONTyped(json, false);
}
export function PreviewIncidentReportResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
        'incidentReportType': !exists(json, 'incidentReportType') ? undefined : json['incidentReportType'],
        'hasContentWarning': !exists(json, 'hasContentWarning') ? undefined : json['hasContentWarning'],
        'countryCode': !exists(json, 'countryCode') ? undefined : json['countryCode'],
        'location': !exists(json, 'location') ? undefined : BountyLocationFromJSON(json['location']),
        'address': !exists(json, 'address') ? undefined : AddressFromJSON(json['address']),
        'incidentDateTime': !exists(json, 'incidentDateTime') ? undefined : (json['incidentDateTime'] === null ? null : new Date(json['incidentDateTime'])),
        'incidentTimezone': !exists(json, 'incidentTimezone') ? undefined : json['incidentTimezone'],
        'incidentDescription': !exists(json, 'incidentDescription') ? undefined : json['incidentDescription'],
        'primaryUserIncidentFileId': !exists(json, 'primaryUserIncidentFileId') ? undefined : json['primaryUserIncidentFileId'],
        'recordedCrashId': !exists(json, 'recordedCrashId') ? undefined : json['recordedCrashId'],
        'thumbnailUrl': !exists(json, 'thumbnailUrl') ? undefined : json['thumbnailUrl'],
        'previewUrl': !exists(json, 'previewUrl') ? undefined : json['previewUrl'],
        'footageCollection': !exists(json, 'footageCollection') ? undefined : (json['footageCollection'] === null ? null : json['footageCollection'].map(PreviewIncidentReportFootageDtoFromJSON)),
        'imageCollection': !exists(json, 'imageCollection') ? undefined : (json['imageCollection'] === null ? null : json['imageCollection'].map(PreviewIncidentReportImageDtoFromJSON)),
    };
}
export function PreviewIncidentReportResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
        'incidentReportType': value.incidentReportType,
        'hasContentWarning': value.hasContentWarning,
        'countryCode': value.countryCode,
        'location': BountyLocationToJSON(value.location),
        'address': AddressToJSON(value.address),
        'incidentDateTime': value.incidentDateTime === undefined ? undefined : (value.incidentDateTime === null ? null : value.incidentDateTime.toISOString()),
        'incidentTimezone': value.incidentTimezone,
        'incidentDescription': value.incidentDescription,
        'primaryUserIncidentFileId': value.primaryUserIncidentFileId,
        'recordedCrashId': value.recordedCrashId,
        'thumbnailUrl': value.thumbnailUrl,
        'previewUrl': value.previewUrl,
        'footageCollection': value.footageCollection === undefined ? undefined : (value.footageCollection === null ? null : value.footageCollection.map(PreviewIncidentReportFootageDtoToJSON)),
        'imageCollection': value.imageCollection === undefined ? undefined : (value.imageCollection === null ? null : value.imageCollection.map(PreviewIncidentReportImageDtoToJSON)),
    };
}
